export var isActionable = function (_a) {
    var isOwner = _a.isOwner, isAuthor = _a.isAuthor, isReportable = _a.isReportable, isSpam = _a.isSpam;
    return (isOwner || isAuthor || isReportable) && !isSpam;
};
//# sourceMappingURL=utils.js.map